import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'db-product-main-pricing',
    templateUrl: './product-main-pricing.component.html',
    styleUrls: ['./product-main-pricing.component.scss'],
    standalone: false
})
export class ProductMainPricingComponent implements OnInit {
  @Input() pricingForm: FormGroup;
  @Input() currencySymbol: { symbol: string };
  @Input() hasAttributes: boolean;

  constructor() {
  }

  ngOnInit() {
  }

}
